import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {RestService} from '../shared/rest/rest.service';
import {map} from 'rxjs/operators';
import {EnvironmentService} from "bos-commons";

@Injectable({
  providedIn: 'root'
})
export class AdminLoggedGuard implements CanActivate {
  constructor(private restService: RestService, private router: Router, private env: EnvironmentService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.activateAction(state);
  }

  public activateAction(state?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
    return this.restService.isAdminLogged().toPromise().then(v => {
      if (v) {
        return Promise.resolve(true);
      } else {
        this.router.navigate(['/accessDenied'], {
          queryParams: {
            redirect_uri: this.env.environment.backendBaseUrl + state?.url
          }
        });
        return Promise.resolve(false);
      }
    }).catch(err => {
      return Promise.resolve(false);
    });
  }

}
